import "react";
import { Constants, Icon, useContainerDimensionsContext } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdComputer } from "react-icons/md";
//#region src/components/RestrictMobileScreenDisplay.tsx
function RestrictMobileScreenDisplay({ children, text }) {
	const { viewport: { width: viewportWidth } } = useContainerDimensionsContext(false);
	if (viewportWidth > Constants.Breakpoint.Sm.width) return children;
	if (viewportWidth < Constants.Breakpoint.Sm.width && text) return /* @__PURE__ */ jsx("div", {
		className: "mt-lg text-color-info h-full w-full",
		children: /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col items-center justify-center",
			children: [/* @__PURE__ */ jsx(Icon, {
				Icon: MdComputer,
				size: "xxl"
			}), /* @__PURE__ */ jsx("div", {
				className: "mt-base p-base text-center text-lg",
				children: text
			})]
		})
	});
	return null;
}
//#endregion
export { RestrictMobileScreenDisplay };

//# sourceMappingURL=RestrictMobileScreenDisplay.js.map